import { useField } from "formik";
import MultiSelect from "../../../../common/MultiSelect";
import { SelectChangeEvent } from "@mui/material";

const PROGRAMME = [
  "Verified Carbon Standard (VCS)",
  "Climate Action Reserve (CAR)",
  "Gold Standard",
  "Plan Vivo",
  "Equitable Earth (EE)",
  "International Carbon Registry (ICR)",
  "Woodland Carbon Code (WCC)",
  "Peatland Carbon Code (PCC)",
  "Puro Standard",
  "DEFRA & Natural England",
  "Other",
];

function CarbonCreditingProgrammeSelect() {
  const fieldPath = "programme-info.carbon-crediting-programme";
  const [field, meta, helpers] = useField(fieldPath);
  const hasError = meta.touched && Boolean(meta.error);
  const selectable = field.value ?? [];

  const handleChange = (event: SelectChangeEvent<Array<string>>) => {
    helpers.setValue(event.target.value);
  };

  const handleSelectedChipRemoval = (programme: string) => {
    helpers.setValue(
      selectable.filter((selected: string) => selected !== programme),
    );
  };

  return (
    <>
      <MultiSelect
        id="solution-programme-info-carbon-crediting-programme"
        label="Carbon Crediting Programme (Standard)"
        selectedValues={selectable}
        onChange={handleChange}
        handleSelectedChipRemoval={handleSelectedChipRemoval}
        options={PROGRAMME}
        errors={hasError}
        touchedText={hasError ? meta.error : undefined}
      />
    </>
  );
}

export default CarbonCreditingProgrammeSelect;
